import React from 'react';
import './SidebarComponent.css';
import { Link, useLocation } from "react-router-dom";
import { useCookies } from 'react-cookie';
import {Squares2X2Icon,
        MagnifyingGlassIcon,
        ArrowsRightLeftIcon,
        ArrowLeftOnRectangleIcon,
        UserIcon,
        ExclamationTriangleIcon, InboxArrowDownIcon,
        TableCellsIcon, CurrencyDollarIcon, DocumentDuplicateIcon } from '@heroicons/react/24/outline'

export default function SidebarComponent() {
  const location = useLocation();
  const [cookies, setCookie, removeCookie] = useCookies(['mazelog-user']);
  const token = cookies['mazelog-user']?.token_data?.access_token;
  
  const userProfile = cookies['mazelog-user']?.user_data?.user_profile;
  const isTransporter = userProfile === "TRANSPORTER" || userProfile === "TRANSPORTER_COLLECTER";
  const isAdmin = userProfile === "ADMIN" || userProfile === "CORP" ;
  const isClient = userProfile === "CLIENT"

  function logout() {
    removeCookie("mazelog-user", {path: "/"});
  }

  return (
    <div className='Sidebar'>
      <div className='PagesList'>
      <Link to="/">
        <h1 className='SidebarTitle'>MAZELOG</h1>
      </Link>
        <Link to='/' className={location.pathname==='/'  ? 'SelectedPageButton' : 'PageButton'}>
          <MagnifyingGlassIcon className='SidebarIcon'/>Pesquisa
        </Link>
        <Link to="/dash" className={location.pathname==='/dash'  ? 'SelectedPageButton' : 'PageButton'}>
          <Squares2X2Icon className='SidebarIcon'/> Dashboard
        </Link>
        { (isClient || isAdmin)  && (
          <Link to='/batches' className={location.pathname==='/batches'  ? 'SelectedPageButton' : 'PageButton'}>
            <TableCellsIcon className='SidebarIcon'/>Etiquetas
          </Link>
        )}
        { ( isAdmin || isTransporter ) && (
          <Link to='/operations' className={location.pathname==='/operations'  ? 'SelectedPageButton' : 'PageButton'}>
            <ArrowsRightLeftIcon className='SidebarIcon'/>Operação
          </Link>
        )}
        { (isTransporter || isAdmin) && (
          <Link to='/finance' className={location.pathname==='/finance'  ? 'SelectedPageButton' : 'PageButton'}>
            <CurrencyDollarIcon className='SidebarIcon'/>Financeiro
          </Link>
        )}
        { (isTransporter || isAdmin) && (
          <Link to='/access' className={location.pathname==='/access'  ? 'SelectedPageButton' : 'PageButton'}>
            <UserIcon className='SidebarIcon'/>Acessos
          </Link>
        )}
        { (isTransporter || isAdmin) && (
          <Link to='/collection' className={location.pathname==='/collection'  ? 'SelectedPageButton' : 'PageButton'}>
          <InboxArrowDownIcon className='SidebarIcon'/>Coleta
        </Link>
        )}
        {(isClient || isAdmin) && (
          <Link to='/create' className={location.pathname==='/create'  ? 'SelectedPageButton' : 'PageButton'}>
            <DocumentDuplicateIcon className='SidebarIcon'/>Criar pedidos
          </Link>
        )}
        <Link to='/occurrence' className={location.pathname==='/occurrence'  ? 'SelectedPageButton' : 'PageButton'}>
          <ExclamationTriangleIcon className='SidebarIcon'/>Ocorrências
        </Link>
      </div>
      <button className='PageButton' onClick={() => logout()}>
        <ArrowLeftOnRectangleIcon className='SidebarIcon'/>Logout
      </button>
    </div>
  );
};